export default __webpack_public_path__ + "static/media/no-respond-found.75bdb901.svg";